<template>
  <div class="page">
    <h2 class="title">个人信息收集清单</h2>
    <table>
      <thead>
      <tr>
        <th>序号</th>
        <th>使用场景</th>
        <th>涉及到权限/个人信息</th>
        <th>目的</th>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td>1</td>
        <td>常规登录/注册</td>
        <td>
          手机号码、验证码、密码、设备信息（包括设备型号、操作系统、唯一设备标识符、软件版本号）
        </td>
        <td>用于注册创建账号和登录</td>
      </tr>
      <tr>
        <td>2</td>
        <td>通信运营商一键登录/注册</td>
        <td>
          网络权限、读取电话状态（获取手机号码），设备信息（包括设备型号、操作系统、唯一设备标识符、软件版本号）
        </td>
        <td>用于手机号的一键免密登录</td>
      </tr>
      <tr>
        <td rowspan="2">3</td>
        <td rowspan="2">信息服务</td>
        <td>Wi-Fi与移动网络权限</td>
        <td>浏览资讯、查看行情</td>
      </tr>
      <tr>
        <td>读写外置储存与相册权限</td>
        <td>用于视频播放</td>
      </tr>
      <tr>
        <td>4</td>
        <td>上传/编辑/分享/下载/图片与音视频</td>
        <td>相机、相册与手机储存、图片</td>
        <td>上传/编辑/分享/下载/图片与音视频、直播</td>
      </tr>
      <tr>
        <td>5</td>
        <td>分享</td>
        <td>
          网络权限，涉及第三方账号的头像、昵称、地区、性别
        </td>
        <td>使用微信功能</td>
      </tr>
      <tr>
        <td>6</td>
        <td>消息通知</td>
        <td>
          推送通知、开机自动运行、振动设备
        </td>
        <td>使用消息通知服务（例如资讯、预警、行业重要公告、系统升级等）</td>
      </tr>
      <tr>
        <td>7</td>
        <td>支付</td>
        <td>
          手机号码、设备信息（包括设备型号、操作系统、唯一设备标识符、软件版本号）
        </td>
        <td>使用支付功能</td>
      </tr>
      <tr>
        <td>8</td>
        <td>营销推广活动</td>
        <td>
          姓名、通信地址、联系方式、银行账号信息（包括：开户行、卡号、开户行地址、所属类型）
        </td>
        <td>参加我们及我们的关联方或第三方举办的有关营销活动</td>
      </tr>
      <tr>
        <td>9</td>
        <td>购买产品或服务</td>
        <td>注册并登录账号，涉及账号信息</td>
        <td>购买并使用我们及我们的关联方向您提供的付费产品或服务</td>
      </tr>
      </tbody>
    </table>
  </div>
</template>
<style>
html,
body {
  background-color: #ffffff;
  word-break: break-all;
}

table {
  margin: 20px 0;
  min-height: 25px;
  line-height: 45px;
  text-align: center;
  border-collapse: collapse;
}

table,
table tr th,
table tr td {
  border: 1px solid #000;
}

td {
  padding: 0 10px;
}

* {
  padding: 0;
  margin: 0;
}

.black body,
body.black {
  background-color: #111112;
  color: #bfbfbf;
}

a {
  color: #4690ef;
}

.page {
  padding: 15px 10px 30px;
  max-width: 750px;
  margin: 0 auto;
  font-size: 30px;
}

.title {
  text-align: center;
}

h2 {
  font-weight: bold;
  font-size: 32px;
  margin: 15px 0;
}

.strong {
  font-weight: bold;
}

p {
  text-indent: 2em;
}

.btn-cancel {
  margin: 45px 22px 0;
  border: 1px solid #dddddd;
  border-radius: 5px;
  line-height: 44px;
  text-align: center;
  font-size: 17px;
  color: #8c8c8c;
  display: none;
}

.black .btn-cancel {
  border-color: #1e262a;
  color: #828282;
}
</style>
<script>
import {Log} from "@em/ym";

export default {
  name: 'PrivacyPersonal',
  mounted() {
    Log.pageView({
      pageId: 'Html:PrivacyPersonal',
    })
  }
}
</script>
